import { Component } from '@angular/core';

@Component({
  selector: 'kh-badge-dot',
  templateUrl: './badge-dot.component.html',
  styleUrl: './badge-dot.component.less',
  standalone: false
})
export class BadgeDotComponent {

}
